<template>
  <div class="orderComp">
    <nav-local-comp :all="'Тех.поддержка'" :id="id" :toAll="toAll"/>
    <tabs-comp :moduleName="moduleName"/>
    <ticket-one-comp v-if="tabs.ticket.active"/>
    <ticket-crud-comp v-if="tabs.crud.active"/>
    <user-one-comp v-if="tabs.user.active" :params="{id: userId}"/>
    <tbl-many-comp v-if="tabs.problems.active" :data="dataProblems" :model="modelProblems"/>
    <gallery-comp v-if="tabs.images.active" :images="images"/>
  </div>
</template>

<script>
export default {
  name: 'orderComp',
  props: {
  },
  data: function () {
    return {
      moduleName: 'tickets',
      required: null
    }
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getOne`, { required: this.required })
  },
  components: {
  },
  computed: {
    id: function () { return this.$store.getters[`${this.moduleName}/getId`] },
    tabs: function () { return this.$store.getters[`${this.moduleName}/getTabs`] },
    userId: function () { return this.$store.getters[`${this.moduleName}/getUserId`] },
    modelProblems: function () {
      let model = this.$store.getters['problems/getModel']
      return this.$helpers.mapper.modelRequired(['id', 'name', 'comment'], model)
    },
    dataProblems: function () {
      let ticket = this.$store.getters[`${this.moduleName}/getOne`]
      return ticket.problems.value
    },
    images: function () {
      let ticket = this.$store.getters[`${this.moduleName}/getOne`]
      return ticket.images.value
    }
  },
  methods: {
    toAll () {
      this.$store.dispatch(`${this.moduleName}/toAll`)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
